import { render, staticRenderFns } from "./PromotionFactorReview.vue?vue&type=template&id=61cc1786&"
import script from "./PromotionFactorReview.vue?vue&type=script&lang=js&"
export * from "./PromotionFactorReview.vue?vue&type=script&lang=js&"
import style0 from "./PromotionFactorReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionFactorReview.vue"
export default component.exports